module.exports = __webpack_public_path__ + "static/media/IMG_8304.eba16bba.png";